import { FC } from 'react'
import { Button } from 'antd'
import type { ButtonProps } from 'antd'

export const GEButton: FC<ButtonProps> = (props) => {
    return (
        <Button  {...props} className={'scale-btn ' + props.className}>
            {props.children}
        </Button>
    )
}